<nav class="navbar">
  <div class="container navbar-content">
    <div class="nav-left">
      <button class="extra-menu-btn" (click)="toggleExtraMenu()">
        <i class="fa-solid" [class.fa-bars]="!isExtraMenuOpen" [class.fa-xmark]="isExtraMenuOpen"></i>
      </button>
      <ul class="nav-links">
        <li class="has-submenu">
          <a (click)="toggleMainSubmenu('buy', $event)" [class.active]="activeSubmenu === 'buy'">Alış <i class="fa-solid fa-angle-up submenu-icon" [class.rotated]="activeSubmenu === 'buy'"></i></a>
        </li>
        <li class="has-submenu">
          <a (click)="toggleMainSubmenu('rent', $event)" [class.active]="activeSubmenu === 'rent'">Kirayə <i class="fa-solid fa-angle-up submenu-icon" [class.rotated]="activeSubmenu === 'rent'"></i></a>
        </li>
        <li><a routerLink="/agents" routerLinkActive="active">Agentlər</a></li>
        <li><a routerLink="/complexes" routerLinkActive="active">Yaşayış kompleksləri</a></li>
      </ul>
    </div>

    <div class="logo">
      <a routerLink="/">
        <svg width="116" height="21" viewBox="0 0 116 21" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M11.9 0L0 10V17L11.9 7L23.8 17V10L11.9 0ZM8.40002 0H1.5V8.2L8.40002 2.4V0Z" fill="#005CE5"/>
          <path d="M41.5 7.19997C40.2 7.19997 39.2 7.69998 38.5 8.79998C37.9 7.69998 37 7.19997 35.7 7.19997C34.4 7.19997 33.5 7.69997 32.8 8.69997V7.39997H31.1V17H32.8V11.7C32.8 9.79997 33.9 8.79998 35.3 8.79998C36.7 8.79998 37.3 9.69998 37.3 11.1V17H39V11.7C39 9.69997 39.9 8.79998 41.4 8.79998C42.9 8.79998 43.5 9.69998 43.5 11.1V17H45.2V11C45.2 8.59997 43.7 7.09998 41.6 7.09998H41.5V7.19997ZM51.9 7.19997C50.4 7.19997 49.2 7.69998 48.3 8.59998C47.4 9.49998 46.9 10.8 46.9 12.2C46.9 13.6 47.4 14.9 48.3 15.8C49.3 16.7 50.5 17.2 52 17.2C53.5 17.2 55.3 16.5 56.2 15L54.8 14.2C54.2 15.1 53.3 15.6 52 15.6C50.7 15.6 48.9 14.6 48.5 12.9H56.5V12.2C56.5 10.8 56.1 9.59998 55.2 8.59998C54.3 7.59998 53.2 7.09998 51.8 7.09998L51.9 7.19997ZM48.6 11.6C48.9 9.89998 50.1 8.79998 51.9 8.79998C53.7 8.79998 54.7 9.79998 55 11.6H48.6ZM63.4 7.19997C62 7.19997 61 7.69998 60.3 8.79998V7.39997H58.6V17H60.3V11.9C60.3 9.69998 61.4 8.69997 63.1 8.69997C64.8 8.69997 65.5 9.59997 65.5 11.2V17H67.2V11.1C67.2 8.69998 65.7 7.09998 63.5 7.09998H63.4V7.19997ZM76.2 8.59998V7.49997H69.2V9.09998H73.9L69 16V17.1H76.4V15.5H71.3L76.2 8.59998ZM79.2 3.49997C78.6 3.49997 78.1 3.99998 78.1 4.59998C78.1 5.19998 78.6 5.69997 79.2 5.69997C79.8 5.69997 80.3 5.19998 80.3 4.59998C80.3 3.99998 79.8 3.49997 79.2 3.49997ZM78.4 17.1H80.1V7.49997H78.4V17.1ZM82.6 17.1H84.3V3.09998H82.6V17.1ZM89.5 4.79998L87.8 5.29998V7.49997H85.9V9.09998H87.8V14.3C87.8 16.7 89.1 17.5 92 17.1V15.6C90.3 15.6 89.4 15.8 89.4 14.3V9.09998H92V7.49997H89.4V4.79998H89.5ZM101.5 9.09998C100.7 7.79998 99.5 7.19997 97.9 7.19997C96.3 7.19997 95.4 7.69997 94.5 8.69997C93.6 9.69997 93.1 10.9 93.1 12.3C93.1 13.7 93.6 14.9 94.5 15.9C95.4 16.9 96.6 17.4 97.9 17.4C99.2 17.4 100.7 16.8 101.5 15.5V17.2H103.2V7.59998H101.5V9.29998V9.09998ZM100.5 14.7C99.8 15.4 99 15.7 98.1 15.7C97.2 15.7 96.3 15.4 95.7 14.7C95 14 94.7 13.2 94.7 12.2C94.7 11.2 95 10.4 95.7 9.79998C96.4 9.09998 97.2 8.79998 98.1 8.79998C99 8.79998 99.9 9.09998 100.5 9.79998C101.2 10.5 101.5 11.3 101.5 12.2C101.5 13.1 101.2 14 100.5 14.7ZM114.4 8.69997C113.5 7.69997 112.3 7.19997 111 7.19997C109.7 7.19997 108.2 7.79998 107.4 9.09998V7.39997H105.7V20.8H107.4V15.3C108.2 16.6 109.4 17.2 111 17.2C112.6 17.2 113.5 16.7 114.4 15.7C115.3 14.7 115.8 13.5 115.8 12.1C115.8 10.7 115.3 9.49997 114.4 8.49997V8.69997ZM113.2 14.7C112.5 15.4 111.7 15.7 110.8 15.7C109.9 15.7 109 15.4 108.4 14.7C107.7 14 107.4 13.2 107.4 12.2C107.4 11.2 107.7 10.4 108.4 9.79998C109.1 9.09998 109.9 8.79998 110.8 8.79998C111.7 8.79998 112.6 9.09998 113.2 9.79998C113.9 10.5 114.2 11.3 114.2 12.2C114.2 13.1 113.9 14 113.2 14.7Z" fill="black"/>
        </svg>
      </a>
    </div>

    <div class="nav-actions">
      <button class="btn btn-primary" (click)="onNewAnnouncementClick()">Yeni elan</button>
      <button class="btn btn-request">Yeni sorğu</button>

      <ng-container *ngIf="auth.isLoggedIn; else showLogin">
        <div class="profile-dropdown">
          <button class="profile-btn">
            <div class="avatar-container">
              <img src="https://api.dicebear.com/7.x/avataaars/svg?seed=Felix&backgroundColor=b6e3f4" alt="Avatar" class="profile-avatar">
            </div>
            <span>Profil</span>
            <i class="fa-solid fa-angle-down"></i>
          </button>
          <ul class="dropdown-menu">
            <li><a routerLink="/profile"><i class="fa-solid fa-user-gear"></i> Şəxsi kabinet</a></li>
            <li><a (click)="logout()"><i class="fa-solid fa-right-from-bracket"></i> Çıxış</a></li>
          </ul>
        </div>
      </ng-container>
      <ng-template #showLogin>
        <button class="btn btn-outline" [routerLink]="['/login']">Giriş</button>
      </ng-template>

      <mat-form-field appearance="outline" class="lang-select">
        <mat-select [(value)]="selectedLanguage">
          <mat-select-trigger>
            <img [src]="getLangFlag(selectedLanguage)" class="flag-icon" [alt]="selectedLanguage">
          </mat-select-trigger>
          <mat-option value="AZ">
            <img src="https://flagcdn.com/w40/az.png" class="flag-icon" alt="AZ">
          </mat-option>
          <mat-option value="EN">
            <img src="https://flagcdn.com/w40/gb.png" class="flag-icon" alt="EN">
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <button class="mobile-menu-btn" (click)="toggleMobileMenu()">
      <span class="bar"></span>
      <span class="bar"></span>
      <span class="bar"></span>
    </button>
  </div>
  <div class="mobile-menu" [class.open]="isMobileMenuOpen">
    <ul>
      <li class="mobile-has-submenu">
        <a (click)="toggleSubmenu('buy')">Alış <i class="fa-solid fa-angle-up arrow" [class.up]="openSubmenus.has('buy')"></i></a>
        <ul class="mobile-submenu" [class.show]="openSubmenus.has('buy')">
          <li><a routerLink="/buy/new-build" (click)="toggleMobileMenu()">Yeni tikili</a></li>
          <li><a routerLink="/buy/old-build" (click)="toggleMobileMenu()">Köhnə tikili</a></li>
          <li><a routerLink="/buy/house" (click)="toggleMobileMenu()">Həyət evi</a></li>
          <li><a routerLink="/buy/office" (click)="toggleMobileMenu()">Ofis</a></li>
          <li><a routerLink="/buy/garage" (click)="toggleMobileMenu()">Qaraj</a></li>
          <li><a routerLink="/buy/land" (click)="toggleMobileMenu()">Torpaq</a></li>
          <li><a routerLink="/buy/commercial" (click)="toggleMobileMenu()">Obyekt</a></li>
        </ul>
      </li>
      <li class="mobile-has-submenu">
        <a (click)="toggleSubmenu('rent')">Kirayə <i class="fa-solid fa-angle-up arrow" [class.up]="openSubmenus.has('rent')"></i></a>
        <ul class="mobile-submenu" [class.show]="openSubmenus.has('rent')">
          <li><a routerLink="/rent/new-build" (click)="toggleMobileMenu()">Yeni tikili</a></li>
          <li><a routerLink="/rent/old-build" (click)="toggleMobileMenu()">Köhnə tikili</a></li>
          <li><a routerLink="/rent/house" (click)="toggleMobileMenu()">Həyət evi</a></li>
          <li><a routerLink="/rent/office" (click)="toggleMobileMenu()">Ofis</a></li>
          <li><a routerLink="/rent/garage" (click)="toggleMobileMenu()">Qaraj</a></li>
          <li><a routerLink="/rent/land" (click)="toggleMobileMenu()">Torpaq</a></li>
          <li><a routerLink="/rent/commercial" (click)="toggleMobileMenu()">Obyekt</a></li>
          <li><a routerLink="/rent/daily" (click)="toggleMobileMenu()">Günlük</a></li>
        </ul>
      </li>
      <li><a routerLink="/agents" (click)="toggleMobileMenu()">Agentlər</a></li>
      <li><a routerLink="/complexes" (click)="toggleMobileMenu()">Yaşayış kompleksləri</a></li>
      <li class="mobile-actions">
        <button class="btn btn-primary w-full" (click)="onNewAnnouncementClick()">Yeni elan</button>
        <button class="btn btn-request w-full">Yeni sorğu</button>

        <ng-container *ngIf="auth.isLoggedIn; else mobileLogin">
          <div class="mobile-profile">
            <div class="mobile-user-info">
              <img src="https://api.dicebear.com/7.x/avataaars/svg?seed=Felix&backgroundColor=b6e3f4" alt="Avatar" class="mobile-avatar">
              <span>Profil</span>
            </div>
            <a class="btn btn-outline w-full" routerLink="/profile" (click)="toggleMobileMenu()">Şəxsi kabinet</a>
            <a class="btn btn-outline w-full" (click)="logout(); toggleMobileMenu()">Çıxış</a>
          </div>
        </ng-container>
        <ng-template #mobileLogin>
          <button class="btn btn-outline w-full" [routerLink]="['/login']" (click)="toggleMobileMenu()">Giriş</button>
        </ng-template>

        <div class="mobile-lang">
          <span>Dil seçimi:</span>
          <mat-form-field appearance="outline" class="lang-select">
            <mat-select [(value)]="selectedLanguage">
              <mat-select-trigger>
                <img [src]="getLangFlag(selectedLanguage)" class="flag-icon" [alt]="selectedLanguage">
              </mat-select-trigger>
              <mat-option value="AZ">
                <img src="https://flagcdn.com/w40/az.png" class="flag-icon" alt="AZ">
              </mat-option>
              <mat-option value="EN">
                <img src="https://flagcdn.com/w40/gb.png" class="flag-icon" alt="EN">
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </li>
    </ul>
  </div>
  <div class="extra-menu" [class.open]="isExtraMenuOpen || activeSubmenu">
    <div class="container">
      <ul class="extra-menu-list" *ngIf="isExtraMenuOpen">
        <li><a routerLink="/about" (click)="toggleExtraMenu()">Layihə haqqında</a></li>
        <li><a routerLink="/terms" (click)="toggleExtraMenu()">İstifadəçi razılaşması</a></li>
        <li><a routerLink="/rules" (click)="toggleExtraMenu()">Qaydalar</a></li>
        <li><a routerLink="/privacy" (click)="toggleExtraMenu()">Məxfilik siyasəti</a></li>
        <li><a routerLink="/advertise" (click)="toggleExtraMenu()">Reklam yerləşdir</a></li>
        <li class="contact-item">
          <span class="mute-text">Bizimlə əlaqə</span>
          <a href="tel:+994500000000" class="phone-link">+994 (50) 000 00 00</a>
        </li>
      </ul>

      <!-- Alış Submenu -->
      <ul class="submenu-grid" *ngIf="activeSubmenu === 'buy'">
        <li><a routerLink="/buy/new-build" (click)="activeSubmenu = null">Yeni tikili</a></li>
        <li><a routerLink="/buy/old-build" (click)="activeSubmenu = null">Köhnə tikili</a></li>
        <li><a routerLink="/buy/house" (click)="activeSubmenu = null">Həyət evi</a></li>
        <li><a routerLink="/buy/office" (click)="activeSubmenu = null">Ofis</a></li>
        <li><a routerLink="/buy/garage" (click)="activeSubmenu = null">Qaraj</a></li>
        <li><a routerLink="/buy/land" (click)="activeSubmenu = null">Torpaq</a></li>
        <li><a routerLink="/buy/commercial" (click)="activeSubmenu = null">Obyekt</a></li>
      </ul>

      <!-- Kirayə Submenu -->
      <ul class="submenu-grid" *ngIf="activeSubmenu === 'rent'">
        <li><a routerLink="/rent/new-build" (click)="activeSubmenu = null">Yeni tikili</a></li>
        <li><a routerLink="/rent/old-build" (click)="activeSubmenu = null">Köhnə tikili</a></li>
        <li><a routerLink="/rent/house" (click)="activeSubmenu = null">Həyət evi</a></li>
        <li><a routerLink="/rent/office" (click)="activeSubmenu = null">Ofis</a></li>
        <li><a routerLink="/rent/garage" (click)="activeSubmenu = null">Qaraj</a></li>
        <li><a routerLink="/rent/land" (click)="activeSubmenu = null">Torpaq</a></li>
        <li><a routerLink="/rent/commercial" (click)="activeSubmenu = null">Obyekt</a></li>
        <li><a routerLink="/rent/daily" (click)="activeSubmenu = null">Günlük</a></li>
      </ul>
    </div>
  </div>
</nav>
